import { render, staticRenderFns } from "./CustomAudioRecorder.vue?vue&type=template&id=20a8d1bf&scoped=true"
import script from "./CustomAudioRecorder.vue?vue&type=script&lang=js"
export * from "./CustomAudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./CustomAudioRecorder.vue?vue&type=style&index=0&id=20a8d1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8d1bf",
  null
  
)

export default component.exports